import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export interface PieEntriesChartData {
  series: number[];
  labels: string[];
}

export const getTrapDetailPieEntriesChartData = async (slug: string, type: TrapType) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.get(`api/v1/traps/charts/pie_chart_by_enters/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: type,
    },
  });

  return data.data as PieEntriesChartData;
};
